import { QUERY_POST_CALL, QUERY_POST_ASSOCIATE_CALL} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';


export const createCallIfNotExists = baseThunk(`call/create`, QUERY_POST_CALL, "POST")
export const associateCall = baseThunk(`call/associateCall`, QUERY_POST_ASSOCIATE_CALL, "POST")



